import React from 'react'
import styled from 'styled-components'
import Mensagem from '../../../../components/Mensagem/Mensagem'
import { bool, func, number, string } from 'prop-types'
import { formatValor } from '../../../../utils/formatter/formatter'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { ORIGENS_COBRANCA, PAGAMENTO_CARTAO, PAGAMENTO_BOLETO, PAGAMENTO_PIX, PLANO_MENSAL } from '../../../../constants'
import {
  AVISO_NOVA_DATA_PAGAMENTO,
  EDITAR,
  TITULO_REGULARIZAR_PAGAMENTO,
  TITULO_REGULARIZAR_PAGAMENTO_BOTAO,
  DESCRICAO_REGULARIZAR_PAGAMENTO,
  TITULO_MENSAGEM_BOLETO_PENDENTE,
  TITULO_MENSAGEM_PIX_PENDENTE
} from './constantsCardPagamentoResumo'

const Titulo = styled.h2`
  margin: 0 0 15px;
`

const WrapperContent = styled.div`
  margin: 0;

  .texto {
    ${StyleGuide.tipografia.textoDefault};
    line-height: 1.6;
    margin: 0 5px 0 0;

    &:last-of-type {
      margin-bottom: 0;
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin: 0 5px 5px 0;

      &.cobranca {
        max-width: 75%;
        margin: 0;
      }
    }
  }
`

const Cobranca = styled.div`
  display: flex;
  align-items: flex-start;

  button {
    padding: 2px 10px;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      max-width: 30%;
    }
  }
`

const TituloNovaDataPagamento = styled.h6`
  ${StyleGuide.tipografia.textoPequeno};
  ${StyleGuide.boldFonte};
  color: ${StyleGuide.cores.azul};
  margin: 0 0 15px;
`

const CardPagamentoResumo = ( {
  acaoPlanoPendente,
  diaCobranca,
  mesTagUltimoKitPago,
  metodoPagamento,
  onEditarDataCobranca,
  pedeCvvPagamentoAutoCobranca,
  podeAutoCobrar,
  tipoPlano,
  urlBoleto,
  urlQrCode,
  valor,
  parcelas,
  vencimento,
  vigenciaPendente,
  codigoPix,
} ) => {
  const origem = ORIGENS_COBRANCA[ acaoPlanoPendente ]

  const getValor = () => {
    const valorParcelas = valor / parcelas
    const isValorPorMes = parcelas !== 1 || tipoPlano === PLANO_MENSAL.visualizacao
    return `${parcelas} x ${formatValor( { 'valor': valorParcelas.toString() } )} ${isValorPorMes ? '/ mês' : ''}`
  }

  return (
    <Card
      className="card"
      largura="100%"
      margin="0 0 30px 0"
    >
      { tipoPlano && tipoPlano === PLANO_MENSAL.visualizacao && vigenciaPendente ?
        <TituloNovaDataPagamento>
          { AVISO_NOVA_DATA_PAGAMENTO }
        </TituloNovaDataPagamento> : null}

      <Titulo>
        { metodoPagamento === PAGAMENTO_CARTAO && !diaCobranca ?
          `Pagamento` : `Pagamento em ${metodoPagamento}`}
      </Titulo>

      <WrapperContent>
        <p className="texto">
          { `Valor: ${getValor()}` }
        </p>

        <p className="texto">
          { `Seu último kit pago: ${mesTagUltimoKitPago}` }
        </p>

        {
          metodoPagamento === PAGAMENTO_BOLETO && vencimento ?
            <p className="texto">
              { `Vencimento do boleto: ${vencimento}` }
            </p> : null
        }

        {
          metodoPagamento === PAGAMENTO_PIX && vencimento ?
            <p className="texto">
              { `Vencimento do Pix: ${vencimento}` }
            </p> : null
        }

        {
          tipoPlano && tipoPlano === PLANO_MENSAL.visualizacao && diaCobranca ?
            <Cobranca>
              <p className="texto cobranca">
                { `Data de cobrança: dia ${diaCobranca}` }
              </p>

              <Button
                invertido
                noBackground
                onClick={ () => onEditarDataCobranca() }
              >
                { EDITAR }
              </Button>
            </Cobranca> : null
        }

        {
          podeAutoCobrar ?
            <Mensagem
              acao={ TITULO_REGULARIZAR_PAGAMENTO_BOTAO }
              handleClick={ () => pedeCvvPagamentoAutoCobranca() }
              texto={ DESCRICAO_REGULARIZAR_PAGAMENTO }
              titulo={ TITULO_REGULARIZAR_PAGAMENTO }
            /> : null
        }

        {
          metodoPagamento === PAGAMENTO_BOLETO && acaoPlanoPendente ?
            <Mensagem
              acao={ urlBoleto ? `Ver boleto` : '' }
              isAlerta
              texto={ `Aguardando pagamento do boleto para efetuar ${origem.artigo} ${origem.texto}.` }
              titulo={ TITULO_MENSAGEM_BOLETO_PENDENTE }
              urlAcao={ urlBoleto }
            /> : null
        }

        {
          metodoPagamento === PAGAMENTO_PIX && acaoPlanoPendente ?
            <Mensagem
              acao={ urlQrCode ? `Ver Pix` : '' }
              imgUrl={ urlQrCode }
              isAlerta
              texto={ `Aguardando pagamento do pix para efetuar ${origem.artigo} ${origem.texto}. Copie o código abaixo e cole no aplicativo. ${codigoPix}` }
              titulo={ TITULO_MENSAGEM_PIX_PENDENTE }
            /> : null
        }
      </WrapperContent>
    </Card>
  )
}

CardPagamentoResumo.propTypes = {
  'acaoPlanoPendente': bool,
  'codigoPix': string,
  'diaCobranca': number,
  'mesTagUltimoKitPago': string.isRequired,
  'metodoPagamento': string.isRequired,
  'onEditarDataCobranca': func,
  'pagamentoPendente': bool,
  'parcelas': number,
  'pedeCvvPagamentoAutoCobranca': func,
  'podeAutoCobrar': bool,
  'tipoPlano': string.isRequired,
  'urlBoleto': string,
  'urlQrCode': string,
  'valor': number.isRequired,
  'vencimento': string,
  'vigenciaPendente': bool
}

CardPagamentoResumo.defaultProps = {
  'acaoPlanoPendente': false,
  'codigoPix': '',
  'diaCobranca': null,
  'onEditarDataCobranca': () => {},
  'pagamentoPendente': false,
  'parcelas': 1,
  'pedeCvvPagamentoAutoCobranca': null,
  'podeAutoCobrar': false,
  'urlBoleto': '',
  'urlQrCode': '',
  'vencimento': null,
  'vigenciaPendente': false
}

export default CardPagamentoResumo
